// extracted by mini-css-extract-plugin
export default {"content":"VHcdNIrSuHH0NucQOHD1","footer":"BgB6BtN_htBXp3rg2pH1","actionsContainer":"DwOFR73JEfp346xqI5yD","error":"qD9f0ZSVL1thFkmsO14g"};